var _style, _defs, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    viewBox: "0 0 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#fff}")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M-.2-.2h16.4v16.3H-.2z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    overflow: "visible"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uBC18\\uBCF5_\\uADF8\\uB9AC\\uB4DC_3",
    clipPath: "url(#SVGID_2_)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-142.5 -98.609)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home_ic_modify",
    transform: "translate(144.5 100.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    className: "st1",
    d: "M-.2 9.7v2.5h2.5l7.3-7.3-2.5-2.5-7.3 7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    className: "st1",
    d: "M8.1 1.4l2.5 2.5 1.6-1.6L9.7-.2 8.1 1.4z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPencil);
export default __webpack_public_path__ + "static/media/ic_pencil.29e859f306b3cb473319bc48c07cbe0c.svg";
export { ForwardRef as ReactComponent };